var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RetailForm',{attrs:{"type":_vm.formType,"buttonLoading":_vm.buttonLoading},on:{"saveRetail":_vm.UpdateRetail}})}
var staticRenderFns = []

export { render, staticRenderFns }